import I18n from 'i18n-js';

import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import styles from './CollectionRankingInfoDialog.module.scss';

type TCollectionRankingInfoDialogProps = {
  onClose: () => void;
  collectionName: string;
};

export function CollectionRankingInfoDialog({
  onClose,
  collectionName,
}: TCollectionRankingInfoDialogProps): JSX.Element {
  return (
    <BottomSheetDialog
      onClose={onClose}
      header={collectionName}
      renderFooter={({ closeDialog }) => (
        <StyledButton
          variant={EStyledButtonVariant.BLUE}
          onClick={closeDialog}
          className={styles.button}
        >
          {I18n.t('common_okay')}
        </StyledButton>
      )}
    >
      <h2 className={styles.headline}>
        {I18n.t('collections_ranking_headline')}
      </h2>
      <p className={styles.text}>{I18n.t('collections_ranking_bs_info')}</p>
    </BottomSheetDialog>
  );
}
